import {GridWidgetService} from './grid-widget-service';
import {WizardService} from './wizard-service';
import {MessageService} from './message-service';
class ServiceInstances {

  private gridWidgetService: GridWidgetService | undefined;
  private wizardService: WizardService | undefined;

  private messageService: MessageService | undefined;

  getGridWidgetService(): GridWidgetService {
    if (this.gridWidgetService == null) {
      this.gridWidgetService = new GridWidgetService();
    }

    return this.gridWidgetService;
  }

  getMessageService(): MessageService {
    if (this.messageService == null) {
      this.messageService = new MessageService();
    }

    return this.messageService;
  }

  getWizardService(): WizardService {
    if (this.wizardService == null) {
      this.wizardService = new WizardService();
    }

    return this.wizardService;
  }
}

export let serviceInstances: ServiceInstances = new ServiceInstances();
